import { render, staticRenderFns } from "./VClubHeader.vue?vue&type=template&id=06713f54&scoped=true&"
import script from "./VClubHeader.vue?vue&type=script&lang=js&"
export * from "./VClubHeader.vue?vue&type=script&lang=js&"
import style0 from "./VClubHeader.vue?vue&type=style&index=0&id=06713f54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06713f54",
  null
  
)

export default component.exports